import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100 ofs" }
const _hoisted_2 = {
  key: 0,
  class: "fr",
  style: {"width":"200px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: `freeform_free`,
  class: "fs12 fw600"
}, "場所の自由入力フォームを設置", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "mt10" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "fl skyblue fs20 ml10",
  style: {"width":"30px","margin-top":"16px"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: /*#__PURE__*/_normalizeClass(`pointer fl mt5`),
  style: {"width":"calc(100% - 60px)"}
}
const _hoisted_11 = {
  class: "fl",
  style: {"width":"60px"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "fs14 fw600" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "fs12 grey"
}
const _hoisted_17 = {
  key: 1,
  class: "fs12 grey"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideSelectFreeBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_CheckboxTag, {
            value: `free`,
            name: `freeform`,
            checked: _ctx.allowFreeForm,
            prefix: `freeform`,
            onClickCheckbox: _ctx.clickFree
          }, null, 8, ["checked", "onClickCheckbox"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentLoctags, (loctag, loctagindex) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(`OnePossibleDate w100 hoverLightGrey pointer ${loctag.selected ? `selected` : ``}`),
          style: `min-height:65px;`,
          key: `${loctagindex}${loctag.id}${_ctx.systemUpdatedAt}`,
          onClick: ($event: any) => (_ctx.selectLocation(loctag))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`${_ctx.isSP ? `` : `fl`} arial dateFormatContent w100`),
            style: {}
          }, [
            (!_ctx.selectOne)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  (loctag.selected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✔"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, " "))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (loctag.public_id != `free`)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${loctag.keyword}`, `60x60`, true)),
                      height: "60",
                      width: "60"
                    }, null, 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.$getAssetImageUrl(`/assets/call/call_free.png`),
                      height: "60",
                      width: "60"
                    }, null, 8, _hoisted_13))
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(loctag.keyword), 1),
              _hoisted_15,
              (loctag.address)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.truncate(loctag.address, 25)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "オンライン"))
            ])
          ], 2),
          _hoisted_18
        ], 10, _hoisted_6))
      }), 128))
    ])
  ]))
}